<template>
  <div class="automan-spinner" v-if="loading">
    <svg class="automan-spinner-body" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="automan-spinner-path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" />
    </svg>
  </div>
  <div v-else-if="info && info.status !== 1 && scene === 'render'">
    <img src="https://res.cdn.changbaimg.com/-/9c0ae381463bf424/empty.png" class="cb-img" alt="">
    <p class="text">您访问的页面已暂停访问</p>
  </div>
  <t-node :info="nodeInfo" v-else-if="nodeInfo" :root="true" @node-mounted="nodeMounted" />
  <div v-else-if="error">
    <img src="https://res.cdn.changbaimg.com/-/9c0ae381463bf424/empty.png" class="cb-img" alt="">
    <p class="text">您访问的页面暂无法访问<br>({{ $route.params.pageKey }})</p>
  </div>
</template>

<style lang="stylus" scoped>
  @require '../../assets/style/base.styl';

  // .page.home {
  // }

  .cb-img {
    display: block;
    width: 130px;
    height: 130px;
    display: block;
    margin: 80px auto 30px;
  }
  .text {
    margin: 0;
    font-size: 18px;
    text-align: center;
    color: #CBCBCB;
  }
</style>

<script>
import BasePage from '../../extend/BasePage'
import TNode from '../../components/PerviewNode'
import {fetch} from '../../extend/fetch'
import emptyPage from '../../assets/data/empty.json'
import getGlobalParams from '../../extend/changba-global-params'
import BrowserLogger from 'alife-logger'
import { initResize, isDesktopShell, readScreenCssWidth, lockViewportRead, MAX_WIDTH, MIN_WIDTH } from '../../assets/js/foldResize'

export default {
  name: 'Home',
  components: {TNode},
  mixins: [BasePage],
  pageName: '',
  data: function () {
    return {
      loading: true,
      info: null,
      nodeInfo: null,
      scene: '',
      error: false
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (to.path != from.path) {
        // 如果页面改变。load新页面加入
        this.loadPageInfo()
      }
    }
  },
  mounted: function () {
    this.loadPageInfo()
    initResize(() => {
      if (this.canvasWidth) {
        this.setViewPort(this.canvasWidth, this.forDesktop)
      }
    })
  },
  methods: {
    async loadPageInfo() {
      this.nodeInfo = null

      let data

      // 检查是否有本地数据
      if (window.__AUTOMAN_PAGE_DATA__ !== undefined) {
        this.scene = 'render'
        data = window.__AUTOMAN_PAGE_DATA__
      }
      else {
        data = await this.loadInfoFromServer()

        if (data === false) {
          this.loading = false
          return
        }
      }

      // 增加前端监控
      if (this.scene === 'render') {
        const globalParams = await getGlobalParams();
        const loggerConfig = {
          pid: 'fgw29hkkce@f9bda640d38de2f',
          appType: 'web',
          imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
          sendResource: true,
          enableLinkTrace: true,
          behavior: true,
          useFmp: true,
          urlHelper: [
            /\/$/
          ],
          ignore: {
            ignoreErrors: [
              /setShareUrlParams/,
              /__changbaPageHideCallback/,
              /bannerNight/,
              /EasylivePageHideCallback/,
              /EasylivePageShowCallback/,
              /^Script error\.?$/
            ]
          },
          uid: globalParams.userId,
          c1: globalParams.appVersion,
          tag: data.name
        };

        BrowserLogger.singleton(loggerConfig);
      }

      this.info = data
      let info = null
      try {
        info = JSON.parse(this.info.content)
      } catch (error) {
        this.error = true
      }

      // 兼容性处理
      if (info?.type === 'truck/emptyContainer') {
        info.type = emptyPage.type
        info.version = emptyPage.version
        info.path = emptyPage.path

        info.child.forEach(item => {
          if (item.type === 'truck/richtext') {
            item.type = 'main/richtext'
            item.version = '1.0.1'
            item.path = 'https://automan.cdn.changbaimg.com/upload/main/richtext/1.0.1/index.js'
          }
        })
      }

      const canvas = info && info.canvas || {}
      const forDesktop = (/desktop/i).test(canvas.name)

      this.canvasWidth = parseInt(canvas.width) || 320
      this.forDesktop = forDesktop
      this.setViewPort(canvas.width, forDesktop)
      this.nodeInfo = info

      // 使用画布的背景色作为 html, body 元素的背景色
      const backgroundColor = info?.style?.['background-color'] ?? ''
      const nodeList = document.querySelectorAll('html, body')

      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].style.backgroundColor = backgroundColor
      }

      this.setPageTitle(data.name || '唱吧')

      this.loading = false
    },

    async loadInfoFromServer() {
      // automan_default_key 用于废弃的 automan proxy，可以忽略
      const pageKey = this.$route.query.automan_default_key ?? this.$route.params.pageKey
      const historyId = this.$route.query.historyid
      const cert = this.$route.query.cert
      const scene = this.$route.query.preview ? 'preview' : historyId ? 'history_preview' : 'render'
      const params = {
        pageKey
      }
      if (historyId) {
        params.historyid = historyId
      }
      if (!pageKey) {
        console.log('缺少页面ID')
        return false
      }

      if (scene === 'preview' && this.$route.query.automan_iframe_preview === 'yes') {
        document.querySelector('html').classList.add('is-preview')
      }

      this.scene = scene

      let data

      if (scene === 'render') {
        ({ data } = await fetch(`${this.Config.API_PATH}page/detail`, {
          method: 'get',
          data: params
        }))
      } else {
        params.scene = scene
        params.cert = cert;
        ({ data } = await fetch(`${this.Config.API_PATH}editor/pages/detail`, {
          method: 'post',
          json: true,
          data: params
        }))
      }

      return data;
    },

    clearFoldLayout() {
      const app = document.getElementById('app')
      document.documentElement.classList.remove('is-fold')
      if (!app) {
        return
      }
      app.style.width = ''
      app.style.maxWidth = ''
      app.style.left = ''
      app.style.marginLeft = ''
    },
    setViewPort (width = 320, forDesktop = false) {
      width = parseInt(width) || 320
      this.canvasWidth = width
      this.forDesktop = forDesktop
      document.documentElement.classList.add(forDesktop ? 'for-desktop' : 'for-mobile')
      const query = document.querySelector.bind(document)
      const rawWidth = readScreenCssWidth()

      if (isDesktopShell()) {
        this.clearFoldLayout()
        this._viewSig = ''
        if (forDesktop) {
          Promise.all([query('#app'), query('#app-wrapper')]).then(([app, wrapper]) => {
            if (app && wrapper) {
              app.style.width = width + 'px'
              query('body').replaceChild(app, wrapper)
            }
          })
        } else {
          // const $appFixed = query('#app-fixed')
          const $appWrapper = query('#app-wrapper')

          if (!$appWrapper) {
            return
          }

          $appWrapper.style.width = width + 'px'
        }
        return
      }

      if (forDesktop) {
        return
      }

      const viewport = document.getElementById('viewport')
      const app = document.getElementById('app')

      // 任何系统下，触屏宽度超过 450 都把画布限制在 450 并居中
      if (rawWidth > MAX_WIDTH) {
        const layoutWidth = Math.round(width * rawWidth / MAX_WIDTH)
        const content = `width=${layoutWidth}, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, shrink-to-fit=no, viewport-fit=cover`
        if (this._viewSig === content) {
          return
        }
        this._viewSig = content
        document.documentElement.classList.add('is-fold')
        if (viewport) {
          lockViewportRead(layoutWidth)
          viewport.setAttribute('content', content)
        }
        if (app) {
          app.style.width = width + 'px'
          app.style.maxWidth = width + 'px'
          app.style.left = '50%'
          app.style.marginLeft = (-width / 2) + 'px'
        }
        return
      }

      this.clearFoldLayout()
      // 320~450 仍按真实宽度缩放；折叠收回时丢掉展开态缓存的宽度
      if (!window.__clientWidth__ || window.__clientWidth__ > MAX_WIDTH) {
        window.__clientWidth__ = rawWidth
      }
      let clientWidth = window.__clientWidth__
      if (clientWidth < MIN_WIDTH) {
        clientWidth = MIN_WIDTH
      }
      const e = clientWidth / width
      const o = `width=${width}, initial-scale=${e}, maximum-scale=${e}, minimum-scale=${e}, user-scalable=no, shrink-to-fit=no, viewport-fit=cover`
      if (this._viewSig === o) {
        return
      }
      this._viewSig = o
      if (viewport) {
        lockViewportRead(width)
        viewport.setAttribute('content', o)
      }
    },
    nodeMounted() {
      this.ema.fire('global:node-mounted');
    }
  }
}
</script>
